import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentViewerModal = ({ isOpen, onClose, document }) => {
  if (!isOpen || !document) return null;

  const isPDF = document?.mime_type === 'application/pdf' || document?.file_path?.toLowerCase().endsWith('.pdf');
  const isImage = document?.mime_type?.startsWith('image/') || 
    ['jpg', 'jpeg', 'png', 'gif', 'webp'].some(ext => document?.file_path?.toLowerCase().endsWith(`.${ext}`));

  const handleDownload = () => {
    if (document?.url) {
      const link = window.document.createElement('a');
      link.href = document.url;
      link.download = document.title || 'document';
      link.target = '_blank';
      window.document.body.appendChild(link);
      link.click();
      window.document.body.removeChild(link);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: 'var(--spacing-lg)'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: 'var(--color-card)',
          borderRadius: 'var(--radius-lg)',
          maxWidth: '90vw',
          maxHeight: '90vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 'var(--spacing-md)',
          borderBottom: '1px solid var(--color-border)'
        }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h3 style={{
              fontFamily: 'var(--font-heading)',
              fontSize: '1.125rem',
              fontWeight: 600,
              color: 'var(--color-foreground)',
              margin: 0,
              marginBottom: '4px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}>
              {document?.title}
            </h3>
            <p style={{
              fontFamily: 'var(--font-caption)',
              fontSize: '0.75rem',
              color: 'var(--color-muted-foreground)',
              margin: 0
            }}>
              {new Date(document?.created_at).toLocaleDateString('fr-CA', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          </div>
          <div style={{ display: 'flex', gap: 'var(--spacing-xs)' }}>
            {document?.url && (
              <Button
                variant="outline"
                size="icon"
                iconName="Download"
                onClick={handleDownload}
                title="Télécharger"
              />
            )}
            <Button
              variant="outline"
              size="icon"
              iconName="X"
              onClick={onClose}
            />
          </div>
        </div>

        {/* Content */}
        <div style={{
          flex: 1,
          overflow: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--spacing-md)',
          background: isPDF ? '#525252' : 'var(--color-background)'
        }}>
          {!document?.url ? (
            <div style={{
              textAlign: 'center',
              color: 'var(--color-muted-foreground)'
            }}>
              <Icon name="FileX" size={48} className="mb-4" />
              <p>Document non disponible</p>
            </div>
          ) : isPDF ? (
            <iframe
              src={document.url}
              style={{
                width: '100%',
                height: '100%',
                minHeight: '600px',
                border: 'none',
                borderRadius: 'var(--radius-md)'
              }}
              title={document.title}
            />
          ) : isImage ? (
            <img
              src={document.url}
              alt={document.title}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
                borderRadius: 'var(--radius-md)'
              }}
            />
          ) : (
            <div style={{
              textAlign: 'center',
              padding: 'var(--spacing-xl)',
              color: 'var(--color-muted-foreground)'
            }}>
              <Icon name="File" size={48} className="mb-4" />
              <p style={{ marginBottom: 'var(--spacing-md)' }}>
                Aperçu non disponible pour ce type de fichier
              </p>
              <Button
                variant="default"
                iconName="Download"
                onClick={handleDownload}
              >
                Télécharger le document
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentViewerModal;
